(() => {
  const config = document.querySelector('script[data-sg-operability]');
  if (!config) return;
  const labelFrame = (frame) => {
    if (frame.title.trim()) return;
    if (frame.id === 'merchantwidgetiframe') frame.title = config.dataset.merchantTitle;
    else if (frame.id.startsWith('web-pixel-sandbox-')) frame.title = config.dataset.analyticsTitle;
  };
  const inspect = (node) => {
    if (!(node instanceof Element)) return;
    if (node.matches('iframe')) labelFrame(node);
    node.querySelectorAll('iframe').forEach(labelFrame);
  };
  inspect(document.documentElement);
  new MutationObserver((records) => {
    records.forEach((record) => {
      if (record.type === 'attributes') inspect(record.target);
      else record.addedNodes.forEach(inspect);
    });
  }).observe(document.documentElement, {childList: true, subtree: true, attributes: true, attributeFilter: ['id', 'title']});
})();
